import { Component, inject } from "@angular/core";
import { UserRolePermissionsService } from "src/app/shared/services/user-role-permissions/user-role-permissions.service";

@Component({
  selector: "im-timelog-container",
  templateUrl: "./timelog-container.component.html",
  styleUrls: ["./timelog-container.component.scss"],
  standalone: false,
})
export class TimelogContainerComponent {
  public toggleValue: "timelog" | "timesheet" = "timelog";

  private readonly userRolePermissionsService = inject(UserRolePermissionsService);

  public get isInspectionsOnlyAccount(): boolean {
    return this.userRolePermissionsService.isInspectionsOnlyAccount();
  }

  public get isTimeManagementOnlyAccount(): boolean {    
    if (this.userRolePermissionsService.isTimeManagementOnlyAccount()) {
      this.toggleValue = "timesheet";
      return true;
    }
    return false;
  }

  public get isInspectionsAndTimeManagementAccount(): boolean {
    return this.userRolePermissionsService.isInspectionsAndTimeManagementAccount();
  }

  public get hasInspectorRole(): boolean {
    return this.userRolePermissionsService.hasInspectorRole();
  }
}
